import { RiskLevel } from '../types/common.types';

const GradientRisk = ({ variant }: { variant: RiskLevel }) => {
  let classRisk = '';
  switch (variant) {
    case RiskLevel.VERY_LOW:
    case RiskLevel.LOW:
      classRisk =
        'bg-gradient-to-br from-[#22A3221A] from-0% to-[#22A32200] to-100% ';
      break;
    case RiskLevel.MEDIUM:
      classRisk =
        'bg-gradient-to-br from-[#EF77311A] from-0% to-[#EF773100] to-100% ';
      break;
    case RiskLevel.HIGH:
      classRisk =
        'bg-gradient-to-br from-[#EC37371A] from-0% to-[#EC373700] to-100% ';
      break;
    default:
      classRisk = 'bg-gradient-to-br from-primary from-0% to-primary to-100% ';
      break;
  }

  return (
    <div
      className={`pointer-events-none absolute bottom-0 left-0 right-0 top-0 flex h-full w-full blur-sm ${classRisk}`}
    ></div>
  );
};

export default GradientRisk;
